import { render, staticRenderFns } from "./CourseListDetail.vue?vue&type=template&id=3146cfe1&scoped=true&"
import script from "./CourseListDetail.vue?vue&type=script&lang=js&"
export * from "./CourseListDetail.vue?vue&type=script&lang=js&"
import style0 from "./CourseListDetail.vue?vue&type=style&index=0&id=3146cfe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146cfe1",
  null
  
)

export default component.exports